import React from "react";
import {  useLocation } from "react-router-dom";
import "./patientDetails.scss";

const PatientAction = () => {
  const location = useLocation();
  
 
  return (
    <>
      
      <div className="action-buttons">
          <div className="card">
            <div className="card-body d-flex justify-content-between">
              <div className="d-flex">
                <p className="action-key-tag"><i class="fa fa-user" aria-hidden="true"></i>&nbsp;:&nbsp;</p>
                <p className="action-value-tag">{location && location?.state?.rowData?.name}</p>
              </div>
              <div className="d-flex">
                <p className="action-key-tag"><i class="fa fa-bed" aria-hidden="true"></i>&nbsp;:&nbsp;</p>
                <p className="action-value-tag">{location && location?.state?.rowData?.ipdNo}</p>
              </div>
              <div className="d-flex">
                <p className="action-key-tag"><i class="fa fa-mobile" aria-hidden="true"></i>&nbsp;:&nbsp;	</p>
                <p className="action-value-tag">{location && location?.state?.rowData?.mobile}</p>
              </div>
              <div className="d-flex">
                <p className="action-key-tag" ><i className="fa fa-calendar"></i>&nbsp;:&nbsp;</p>
                <p className="action-value-tag">{new Date(location && location?.state?.rowData?.admissionDate)?.toLocaleDateString()}</p>
              </div>
            </div>
          </div>
      </div> 
    </>
  )
}

export default PatientAction;